/**
 * BaseTheme rework now uses javascript version ES6
 * ------
 *
 * Functions and Variables are no longer global and need to be imported
 * ( How to prepare function for export can be seen in `utils.js` )
 */
import { customEvents, initUtils } from './utils';
import { initStickyMenu } from './navigation/stickyMenu';
import { initMobileMenu } from './navigation/mobileMenu';
import { initCountUp } from './counter';
import { initAboutSliders } from './glide-about';
import { initStudiesSliders } from './glide-studies';
import { initReferencesSliders } from './glide-references';
import { initChangingBackground } from './changing-bg';
import { initIframeCSS } from './iframe-css';
import { initShareButtons } from './block-sharer';
import { initPostFooter } from './block-post-footer';
import { initBlockSlider } from './block-slider';
import { setupFOUCPreventer } from './gridbuilder';
/**
 * This function or DOMContentLoaded event is necesary for compiling to work
 *
 * Standalone functions will be removed on compile, so function that is called only in onclick event for example will be removed
 */

function initAllScripts() {
    initUtils();
    initStickyMenu();
    initMobileMenu();
    initCountUp();
    initAboutSliders();
    initStudiesSliders();
    initReferencesSliders();
    initChangingBackground();
    initIframeCSS();
    initShareButtons();
    initPostFooter();
    setupFOUCPreventer();
    initBlockSlider();
}

if (document.readyState !== 'loading') {
    initAllScripts();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initAllScripts();
    });
}
